module.exports = __webpack_public_path__ + "static/media/dhanyabad didi.f87a3eaf.wav";